import { useState, useEffect } from "preact/hooks";
import useDebounce from "../useDebounce";

export default function useSearch({ searchRoute = "/search", terms }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const debouncedTerms = useDebounce(terms, 300, [""]);

  useEffect(() => {
    if (terms !== debouncedTerms) {
      setLoading(true);
    }
  }, [terms, debouncedTerms]);

  useEffect(() => {
    if (debouncedTerms === "") {
      setData({
        searchTerm: "",
        resultsCount: 0,
        ids: [],
        pages: [],
        articles: [],
      });
      return;
    }

    const url = new URL(window.location.origin);
    url.pathname = searchRoute;
    url.searchParams.set("type", "product,page,article");
    url.searchParams.set("q", debouncedTerms);
    setLoading(true);

    fetch(url)
      .then((res) => res.text())
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const searchEl = doc.querySelector("[data-search-results-data]");
        setData(JSON.parse(searchEl.innerHTML));
        setLoading(false);
      });
  }, [debouncedTerms]);

  return [loading, data];
}
